/**
 * Service: logger
 */
angular.module('acme.common.service.logger', [])
.service('LoggerService', [function() {

    return {

      logs: [],

      init: function() {},

      log: function(message) {
        this.logs.push(message);
      },

      get: function(index) {
        return this.logs[index];
      },

      errors: function(stringify, flush) {
        var r = false,
            e = '',
            i, ii,
            _logs,
            _errors = [];

        for (i=0,ii=this.logs.length;i<ii;i++) {
          if (this.logs[i] && this.logs[i].error) {
            e = this.logs[i].error.data;
            if (this.logs[i].error.data) {
              e = this.logs[i].error.data;
            }else{
              e = this.logs[i].error;
            }
            if (stringify) {
              _errors.push(angular.toJson(e, true));
            }else{
              _errors.push(e);
            }
          }
        }

        if (flush) {
          _logs = this.flush();
        }else{
          _logs = this.logs;
        }

        if (_logs.length) {
          r = {
            errors: stringify ? _errors.join('\n') : _errors,
            logs: _logs
          };
        }

        return r;

      },

      flush: function() {
        return this.logs.splice(0, this.logs.length);
      }

    };

}]);